export const siteSettings = {
  name: "Bitnix",
  link: "https://bitnixpro.live",
  email: "support@bitnixpro.live",
  appLink: "https://app.bitnixpro.live",
};
